import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { queryClient } from './services/queryClient';
import { initQZ } from './printing/qzInit';

function waitForQZ(retries = 20) {
  if (window.qz) {
    initQZ();
    return;
  }
  if (retries > 0) {
    setTimeout(() => waitForQZ(retries - 1), 250);
  }
}

waitForQZ();

// Persists the cache (currently just the product catalog, see useAllProducts)
// to localStorage so Chrome discarding an idle/background tab — which tears
// down the in-memory QueryClient just like a full reload — doesn't force a
// full catalog re-fetch on the next visit.
const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'GF_QUERY_CACHE',
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: localStoragePersister,
        maxAge: 24 * 60 * 60 * 1000, // 24h — bounds how long a persisted, never-refreshed tab can serve a stale catalog
      }}
    >
      <App />
    </PersistQueryClientProvider>
  </React.StrictMode>
);

// Start measuring performance in your app
reportWebVitals();
